import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allOrders: [{}],
  customerOrders: [{}],
  order: {},
  historyLog: {},
  customerHistoryLog: [{}],
  error: null,
};

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setReducerError: (state, action) => {
      state.error = action.error;
    },
    setAllOrders: (state, action) => {
      state.allOrders = action.payload;
      state.error = null;
    },
    setCustomerOrders: (state, action) => {
      state.customerOrders = action.payload;
      state.error = null;
    },
    setOrder: (state, action) => {
      state.order = action.payload;
      state.error = null;
    },
    setHistoryLog: (state, action) => {
      state.historyLog = action.payload;
      state.error = null;
    },
    setCustomerHistoryLog: (state, action) => {
      state.customerHistoryLog = action.payload;
      state.error = null;
    },
    setResetOrder: () => {
      return initialState;
    },
  },
});

export const {
  setReducerError,
  setAllOrders,
  setCustomerOrders,
  setOrder,
  setHistoryLog,
  setCustomerHistoryLog,
  setResetOrder,
} = orderSlice.actions;

export default orderSlice.reducer;
